import React from "react";
import * as S from "./ChatInterfaceStyles";
import { ListType } from "./MessagePreprocessor";

interface DynamicListProps {
  list: ListType;
}

const DynamicList: React.FC<DynamicListProps> = ({ list }) => {
  const isNumbered = list.style === "numbered";
  const Wrapper: any = isNumbered ? "ol" : "ul";
  return (
    <S.TableWrapper>
      <Wrapper>
        {list.items.map((item, i) => {
          const label = typeof item === "string" ? item : item.label;
          const value = typeof item === "string" ? undefined : item.value;
          return (
            <li key={i}>
              {label}
              {value ? ": " + value : ""}
            </li>
          );
        })}
      </Wrapper>
    </S.TableWrapper>
  );
};

export default DynamicList;
